import { useEffect } from "react"
import { string } from "prop-types"
import { Redirect } from "@reach/router"
import { Loading } from "source/shared/Loading"

export function HardRefresh() {
  useEffect(() => {
    !__TEST__ && window.location.replace(location.href)
  })
  return <Loading />
}

Unproxy.propTypes = { ["*"]: string }
export function Unproxy(props) {
  const pathname = "/" + props["*"]
  return <Redirect to={pathname} noThrow />
}
